import { z } from 'zod';
export var ChatContextType;
(function (ChatContextType) {
    ChatContextType["Global"] = "global";
    ChatContextType["KolProfile"] = "kol-profile";
    ChatContextType["Document"] = "document";
    ChatContextType["Folder"] = "folder";
    ChatContextType["Brand"] = "brand";
    ChatContextType["Agent"] = "agent";
    ChatContextType["Transcript"] = "transcript";
    ChatContextType["Project"] = "project";
})(ChatContextType || (ChatContextType = {}));
export var ChatInstanceItemType;
(function (ChatInstanceItemType) {
    ChatInstanceItemType[ChatInstanceItemType["Query"] = 1] = "Query";
    ChatInstanceItemType[ChatInstanceItemType["FileUpload"] = 2] = "FileUpload";
    ChatInstanceItemType[ChatInstanceItemType["KolSearch"] = 3] = "KolSearch";
})(ChatInstanceItemType || (ChatInstanceItemType = {}));
export var ChatFileUploadStatus;
(function (ChatFileUploadStatus) {
    ChatFileUploadStatus["Errored"] = "errored";
    ChatFileUploadStatus["Initiated"] = "initiated";
    ChatFileUploadStatus["Started"] = "started";
    ChatFileUploadStatus["Ready"] = "ready";
    ChatFileUploadStatus["Uploaded"] = "uploaded";
})(ChatFileUploadStatus || (ChatFileUploadStatus = {}));
export var ChatHintType;
(function (ChatHintType) {
    ChatHintType["AnalysisTags"] = "analysis-tags";
    ChatHintType["FindQuotes"] = "find-quotes";
    ChatHintType["Text"] = "text";
    ChatHintType["Chart"] = "chart-quant-analyses";
})(ChatHintType || (ChatHintType = {}));
export var ChatCitationType;
(function (ChatCitationType) {
    ChatCitationType["Generic"] = "generic";
    ChatCitationType["KolProfile"] = "kol-profile";
    ChatCitationType["Document"] = "document";
    ChatCitationType["Transcript"] = "transcript";
    ChatCitationType["CrmNote"] = "crm-note";
    ChatCitationType["StrategicImperative"] = "strategic-imperative";
    ChatCitationType["Dashboard"] = "dashboard";
    ChatCitationType["ScientificLeaderTopic"] = "scientific-leader-topic";
    ChatCitationType["ClinicalLeaderTopic"] = "clinical-leader-topic";
    ChatCitationType["DigitalLeaderTopic"] = "digital-leader-topic";
    ChatCitationType["Association"] = "association";
    ChatCitationType["Affiliation"] = "affiliation";
    ChatCitationType["Collaboration"] = "collaboration";
    ChatCitationType["CompanySponsorship"] = "company-sponsorship";
    ChatCitationType["ClinicalTrial"] = "clinical-trial";
    ChatCitationType["Conference"] = "conference";
    ChatCitationType["Publication"] = "publication";
    ChatCitationType["CongressAbstract"] = "congress-abstract";
    ChatCitationType["UnmetNeed"] = "unmet-need";
    ChatCitationType["ContactDetail"] = "contact-detail";
    ChatCitationType["Recommendation"] = "recommendation";
    ChatCitationType["DocumentedInterests"] = "documented-interests";
    ChatCitationType["MedicalInsights"] = "medical-insights";
    ChatCitationType["CallCenterInteractions"] = "call-center-interactions";
    ChatCitationType["FbmsInteractions"] = "fbms-interactions";
    ChatCitationType["QuantAnalysis"] = "quant_analysis";
    ChatCitationType["SurveyQuestionResponses"] = "survey_question_responses";
    ChatCitationType["SegmentPersona"] = "segment_persona";
})(ChatCitationType || (ChatCitationType = {}));
export var ChatHistoryMode;
(function (ChatHistoryMode) {
    ChatHistoryMode["All"] = "all";
    ChatHistoryMode["Page"] = "page";
})(ChatHistoryMode || (ChatHistoryMode = {}));
export var ChatQueryStatus;
(function (ChatQueryStatus) {
    ChatQueryStatus["Error"] = "error";
    ChatQueryStatus["Loading"] = "loading";
    ChatQueryStatus["LoadingExtended"] = "loading-extended";
    ChatQueryStatus["Streaming"] = "streaming";
    ChatQueryStatus["Complete"] = "complete";
    ChatQueryStatus["FollowupsAvailable"] = "followups-available";
})(ChatQueryStatus || (ChatQueryStatus = {}));
export var ChatResponseType;
(function (ChatResponseType) {
    ChatResponseType["HcpAvailability"] = "hcp-availability";
    ChatResponseType["HcpSummary"] = "hcp-summary";
    ChatResponseType["Markdown"] = "markdown";
    ChatResponseType["HcpSelection"] = "hcp-selection";
    ChatResponseType["MarkdownHtml"] = "markdown-html";
    ChatResponseType["Text"] = "raw-text";
    ChatResponseType["LocationSelection"] = "location-selection";
    ChatResponseType["Chart"] = "chart";
    ChatResponseType["LocationRouting"] = "routing-response";
    ChatResponseType["SchedulingAssistant"] = "scheduling-assistant";
    ChatResponseType["FormWorkflow"] = "form-workflow";
    ChatResponseType["SmartRouting"] = "smart-routing";
    // Response types from BIAI
    ChatResponseType["BIFindQuotes"] = "find-quotes-response";
    ChatResponseType["BIFindQuantAnalyses"] = "find-quant-analyses-response";
    ChatResponseType["BIChartQuantAnalyses"] = "chart-quant-analyses-response";
    // Segmentation workflow response types
    ChatResponseType["SegmentationTagsNeeded"] = "segmentation-tags-needed";
    ChatResponseType["SegmentationQuestionsNeeded"] = "segmentation-questions-needed";
    ChatResponseType["SegmentationComplete"] = "segmentation-complete";
    ChatResponseType["SegmentationCancelled"] = "segmentation-cancelled";
})(ChatResponseType || (ChatResponseType = {}));
export var ChatAttachmentType;
(function (ChatAttachmentType) {
    ChatAttachmentType["Table"] = "table";
    ChatAttachmentType["Chart"] = "chart";
    ChatAttachmentType["SuggestedActions"] = "suggested-actions";
    ChatAttachmentType["HCPSearch"] = "hcp-search";
})(ChatAttachmentType || (ChatAttachmentType = {}));
export var ChatActionType;
(function (ChatActionType) {
    ChatActionType["ReaskWithHcp"] = "reask-with-hcp";
    ChatActionType["SelectLocation"] = "select-location";
    ChatActionType["BuildRoute"] = "build-route";
    ChatActionType["SmartRouting"] = "smart-routing";
    ChatActionType["QueryFiles"] = "query-files";
    ChatActionType["FindQuotes"] = "find-quotes";
    ChatActionType["QuerySurveyQuestion"] = "query-survey-question";
    ChatActionType["SubmitFormWorkflow"] = "submit-form-workflow";
    ChatActionType["SummarizeFolder"] = "summarize-folder";
    ChatActionType["LoadDraft"] = "load-draft";
    ChatActionType["FindQuantAnalyses"] = "find-quant-analyses";
    ChatActionType["ChartQuantAnalyses"] = "chart-quant-analyses";
    ChatActionType["AnswerQuantAnalyses"] = "answer-quant-analyses";
})(ChatActionType || (ChatActionType = {}));
export const ChatActionTypeModel = z.nativeEnum(ChatActionType);
export var CopilotConfigAction;
(function (CopilotConfigAction) {
    CopilotConfigAction["FormEntry"] = "dispatch:form-entry";
    CopilotConfigAction["ProfileRecommendations"] = "dispatch:profile-recommendations";
    CopilotConfigAction["Workspaces"] = "navigate:workspaces";
    CopilotConfigAction["QuestionsBank"] = "dispatch:questions-bank";
})(CopilotConfigAction || (CopilotConfigAction = {}));
export var CopilotConfigIcon;
(function (CopilotConfigIcon) {
    CopilotConfigIcon["Schedule"] = "schedule";
    CopilotConfigIcon["FormEntry"] = "form-entry";
    CopilotConfigIcon["Insights"] = "insights";
    CopilotConfigIcon["ProfileRecommendations"] = "profile-recommendations";
    CopilotConfigIcon["Workspaces"] = "workspaces";
    CopilotConfigIcon["QuestionsBank"] = "questions-bank";
    CopilotConfigIcon["QuestionsBankAlt"] = "questions-bank-alt";
})(CopilotConfigIcon || (CopilotConfigIcon = {}));
export var BiChatContextType;
(function (BiChatContextType) {
    BiChatContextType["Global"] = "bi-global";
    BiChatContextType["Brand"] = "bi-brand";
    BiChatContextType["Document"] = "bi-document";
    BiChatContextType["Folder"] = "bi-folder";
    BiChatContextType["Project"] = "bi-project";
    BiChatContextType["Transcript"] = "bi-transcript";
})(BiChatContextType || (BiChatContextType = {}));
export const BrandInsightChatContexts = [
    BiChatContextType.Brand,
    BiChatContextType.Document,
    BiChatContextType.Folder,
    BiChatContextType.Project,
    BiChatContextType.Transcript,
    BiChatContextType.Global,
];
export var EngagementType;
(function (EngagementType) {
    EngagementType["Proactive"] = "Proactive";
    EngagementType["Reactive"] = "Reactive";
    EngagementType["None"] = "None";
})(EngagementType || (EngagementType = {}));
export var ChatPlatform;
(function (ChatPlatform) {
    ChatPlatform["BrandInsights"] = "brand-insights";
    ChatPlatform["GenAIPlatform"] = "genai-platform";
})(ChatPlatform || (ChatPlatform = {}));
